module.exports = __webpack_public_path__ + "img/account_login_bg.4b52234d.png";